import React, { createContext, useState, useContext, useCallback } from "react";
import { Kount } from "components/Kount";
import * as utils from "utils";

const pre = "[FC]";

const FraudCheckContext = createContext();

export const FraudCheckProvider = (props) => {
  const { debug } = utils.useSessionCtx();
  const [complete, setComplete] = useState(false);

  const handleComplete = useCallback(() => {
    debug(pre, "COMPLETE");
    setComplete(true);
  }, [debug]);

  const handleError = useCallback(
    (e) => {
      debug(pre, "ERROR", e);
    },
    [debug]
  );

  const value = {
    fraudCheckComplete: complete,
    fraudCheckComponent: <Kount onComplete={handleComplete} onError={handleError} />,
  };
  return <FraudCheckContext.Provider value={value} {...props} />;
};

export const useFraudCheck = () => useContext(FraudCheckContext);
